import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-[70vh] flex-col items-center justify-center px-4 py-20 text-center">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-50 text-4xl text-primary-500">
        <i className="ri-file-search-line"></i>
      </span>
      <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        页面不存在或内容已下线
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的地址没有找到对应的影视内容，可能是链接有误，或者该作品暂时没有被收录。
      </p>
      <p className="mt-2 rounded-md bg-background-100 px-3 py-1 font-mono text-xs text-foreground-500">
        {location.pathname}
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer dark:text-foreground-950"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/drama"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
        >
          <i className="ri-movie-line"></i>
          浏览影视分类
        </Link>
      </div>
    </div>
  );
}